import { EnvironmentContext } from '@wap-client/constants'
import { request } from '@wap-client/services'

export interface searchAllDomainParams {
  language: string
  search: string
}

export interface SearchAllDomainResponseItem {
  domain: string
  title: string
  url: string
}

export interface SearchAllDomainResponse {
  data: Array<SearchAllDomainResponseItem>
}

export const searchAllDomain = (
  environment: EnvironmentContext,
  params: searchAllDomainParams,
) =>
  request<SearchAllDomainResponseItem[]>(environment, {
    method: 'get',
    url: 'https://api.goturkiye.com/core/goturkiye/post/search/all-domains',
    params: {
      pageSize: 200,
      searchValue: params.search,
      language: params.language.substring(0, 2),
    },
  })
